import {
  API,
  get,
  post,
  put,
  remove,
  postViaWebWorker,
  getViaWebWorker,
  removeHaveData
} from './API'
import * as constants from '../../mixins/constants'

export const getListEmployees = (params) => API().get(constants.API.partner.get_child_list, params)

export const login = (params) => {
  const uri = constants.API.user.auth.login
  return post(uri, params, {
    token_required: false,
    stringify_data: false,
    timeout: 30000
  })
}

export const partnerActivate = (params) => {
  const uri = constants.API.user.auth.partner_activate
  return post(uri, params, {
    token_required: false,
    stringify_data: false,
    timeout: 30000
  })
}

export const momoActivate = (params) => {
  const uri = constants.API.user.auth.momo_activate
  return post(uri, params, {
    token_required: false,
    stringify_data: false,
    timeout: 30000
  })
}

export const viettelActivate = (params) => {
  const uri = constants.API.user.auth.viettel_activate
  return post(uri, params, {
    token_required: false,
    stringify_data: false,
    timeout: 30000
  })
}

export const zalopayActivate = (params) => {
  const uri = constants.API.user.auth.zalopay_activate
  return post(uri, params, {
    token_required: false,
    stringify_data: false,
    timeout: 30000
  })
}

export const exchangeSupplier = ({ token }) => {
  const uri = constants.API.user.auth.exchange_supplier
  return post(
    uri,
    {},
    {
      token_required: false,
      timeout: 30000,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
}

export const socialLogin = (params) => {
  const uri = constants.API.user.auth.social_login
  return post(uri, params, { token_required: false, stringify_data: false })
}

export const activate = (params) => {
  const uri = constants.API.user.auth.activate
  return post(uri, params, { token_required: false, stringify_data: false })
}

export const register = (params) => {
  const uri = constants.API.user.auth.register
  return post(uri, params, { token_required: false, stringify_data: false })
}

export const logout = (params) => {
  const uri = constants.API.user.auth.logout
  return get(uri, params)
}

export const authorizeSharedLink = (params) => {
  const uri = constants.API.rest_api.user_authorize_shared_link
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 20000
  })
}

export const updatePush = (params) => {
  const uri = constants.API.user.update_push
  return put(uri, params)
}

export const updateLanguage = (params) => {
  const uri = constants.API.user.update_language
  return put(uri, params, {
    stringify_data: false,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const refreshFirebaseToken = (params) => {
  const uri = constants.API.user.refresh_firebase_token
  return get(uri, params)
}

export const getPushData = (params) => {
  const uri = constants.API.user.get_push_data
  return get(uri, params)
}

export const updateProfile = (params) => {
  const uri = constants.API.user.update_profile
  return post(uri, params, { stringify_data: false })
}

export const verify = (params) => {
  const uri = constants.API.user.verify
  return get(uri, params)
}

export const transaction = (params) => {
  const uri = constants.API.user.transaction
  return get(uri, params)
}

export const balance = (params) => {
  const uri = constants.API.user.balance
  return get(uri, params)
}

export const updateReferralCode = (params) => {
  const uri = constants.API.user.update_referral_code
  return put(uri, params)
}

export const profile = (params, config = {}) => {
  const uri = constants.API.user.profile
  const _config = { ...config, token_required_header: true }

  return get(uri, params, _config)
}

export const logEvent = (params) => {
  const uri = constants.API.user.log_event
  return get(uri, params)
}

export const getPromoCodes = (params) => {
  const uri = constants.API.user.get_promo_codes
  return get(uri, params)
}

export const topUp = (params) => {
  const uri = constants.API.payment.top_up
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getListPaymentMethods = (param) => {
  const uri = `${constants.API.payment.list_payment_methods}${param.payment_type}`
  return getViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

export const addBankAccount = (params) => {
  const uri = constants.API.payment.add_bank_account
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const withdraw = (params) => {
  const uri = constants.API.payment.update_balance
  return get(uri, params)
}

export const deleteBankAccount = (params) => {
  const uri = constants.API.payment.remove_bank_account
  return get(uri, params)
}

export const codTransactions = (params) => {
  const uri = constants.API.payment.cod_transactions
  return get(uri, params)
}

export const exchangeFacebookToken = (params) => {
  const uri = constants.API.rest_api.user_exchange_facebook_token
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_REST_API,
    token_required: true
  })
}

export const getOtp = (params) => {
  const uri = constants.API.user.get_otp
  return get(uri, params)
}

export const getUserCategory = (params = {}) => {
  const _params = {
    ...params,
    format: 'list'
  }

  const uri = constants.API.user.get_user_category
  return getViaWebWorker(uri, _params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const addPointReward = (params = {}) => {
  const uri = constants.API.user.add_point_reward
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_API_PT_URL
  })
}

export const getSavedPlaces = (params) => {
  const uri = constants.API.user.saved_places
  return getViaWebWorker(uri, params, {})
}

export const addSavedPlace = (params) => {
  const uri = constants.API.user.saved_places
  return post(uri, params, {
    stringify_data: false
  })
}

export const updateSavedPlace = (params) => {
  const uri = constants.API.user.saved_places
  return put(uri, params, {
    stringify_data: false
  })
}

export const deleteSavedPlace = (id) => {
  const uri = `${constants.API.user.saved_places}/${id}`

  return remove(
    uri,
    {},
    {
      stringify_data: false
    }
  )
}

// Referral
export const checkValidReferrer = (params) => {
  const uri = constants.API.user.check_valid_referrer
  return get(uri, params)
}

export const getReferralHistory = () => {
  const uri = constants.API.user.get_referral_history
  return get(uri, {}, { token_required: true })
}

export const getReferralDetail = (params) => {
  const uri = constants.API.user.get_referral_detail + '/' + params.referral_id
  return get(uri, {}, { token_required: true })
}
// end Referral

export const switchStatusAutoTransferCod = (params) => {
  const uri = constants.API.user.switch_status_auto_transfer_cod
  return post(uri, params, { token_required: false, stringify_data: false })
}

// Subscriptions

export const getSubscriptionsList = (params) => {
  const uri = constants.API.user.subscription.subscription_list
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_OPSTECH_API_URL,
    timeout: 20000
  })
}

export const getSubscriptionDetail = (params) => {
  const uri = constants.API.user.subscription.subscription_detail
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_OPSTECH_API_URL,
    timeout: 20000
  })
}

export const getMySubscriptionList = (params) => {
  const uri = constants.API.user.subscription.my_subscription_list
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_OPSTECH_API_URL,
    timeout: 20000
  })
}

export const getMySubscriptionDetail = (params) => {
  const uri = constants.API.user.subscription.my_subscription_detail
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_OPSTECH_API_URL,
    timeout: 20000
  })
}

export const paymentSubscription = (params) => {
  const uri = constants.API.payment.subscription
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// export const getListPaymentMethodsSubscription = (params = {}) => {
//   const uri = constants.API.user.subscription.get_list_payment_methods_subscription
//   return getViaWebWorker(uri,params, {
//     baseURL: process.env.VUE_APP_API_URL,
//     timeout: 20000
//   });
// }

export const checkStatusTransactionSubscription = (params) => {
  const uri = `${constants.API.user.subscription.checkStatusTransaction}/status`
  return getViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

export const updateRenew = (params) => {
  const uri = constants.API.user.subscription.my_subscription_update
  return postViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_OPSTECH_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// end Subscriptions

// Binding ZaloPay

export const bindZaloPay = (param) => {
  const uri = `${constants.API.payment.zalopay.binding}`
  return postViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const bindMomo = (param) => {
  const uri = `${constants.API.payment.zalopay.binding}`
  return postViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const unbindWallet = (param) => {
  const uri = `${constants.API.payment.unbinding}`
  return postViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// export const checkBalanceZaloPay = (param) => {
//   const uri = constants.API.payment.zalopay.check_remain;
//   return postViaWebWorker(uri, param, {
//     baseURL: process.env.VUE_APP_API_URL,
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
// };

export const sendTicket = (param) => {
  const uri = `${constants.API.ticket.create_ticket}`
  return getViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

// Verify Account

export const verifyUserDocuments = (param) => {
  const uri = `${constants.API.admin.user_verify}`
  return getViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_UPLOAD_USER_DOCUMENTS,
    timeout: 20000
  })
}

export const verifyUserDocumentsFPT = (param) => {
  const uri = `${constants.API.ekyc.verify}`
  return postViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

export const linkSocialByFB = (param) => {
  const uri = `${constants.API.user.auth.link_social_account}`
  return getViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

export const verifyAccount = (data) => {
  const uri = `${constants.API.user.verify_account}`
  return postViaWebWorker(uri, data, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// Pay order by ZaloPay
export const payOrderByZaloPay = (params, config = {}) => {
  const uri = `${constants.API.payment.pay_order}`
  return postViaWebWorker(uri, params, config)
}

export const generateAuthToken = () => {
  const uri = `${constants.API.user.generate_auth_token_hv}`

  return postViaWebWorker(
    uri,
    {},
    {
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}

// export const userVerifyHyperVerge = (data) => {
//   const uri = `${constants.API.admin.user_verify_hyperverge_v2}`;

//   return postViaWebWorker(uri, {}, {
//     baseURL: process.env.VUE_APP_USER_DOCUMENTS_OPTECH_URL,
//     headers: {
//       "Content-Type": "multipart/form-data"
//     },
//     body: data
//   })
// }

export const payOrderByZaloPayWithAutoDebit = (params) => {
  const uri = `${constants.API.payment.pay_order}`
  return postViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Is-Auto-Debit': true
    }
  })
}

export const payOrderByMomoWithAutoDebit = (params) => {
  const uri = `${constants.API.payment.pay_order}`
  return postViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Is-Auto-Debit': true
    }
  })
}

export const getNews = (params) => {
  const uri = constants.API.user.news
  return getViaWebWorker(uri, params)
}

export const getPublicNews = (params) => {
  const uri = constants.API.user.public_news
  return getViaWebWorker(uri, params, {
    token_required: false
  })
}

export const getScreenConfig = (params) => {
  const uri = constants.API.user.screen_config
  return getViaWebWorker(uri, params)
}

export const getDriver = (params) => {
  const uri = constants.API.user.favorite_drivers
  return getViaWebWorker(uri, params)
}

export const addDriver = (params) => {
  params.list = 'FAVORITE'
  const uri = constants.API.user.add_driver
  return getViaWebWorker(uri, params)
}

export const removeDriver = (params) => {
  params.list = 'BANNED'
  const uri = constants.API.user.add_driver
  return getViaWebWorker(uri, params)
}
// Binding ShopeePay
export const bindShopeePay = (param) => {
  const uri = `${constants.API.payment.shopeepay.binding}`
  return postViaWebWorker(uri, param, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// Pay order by ShopeePay
export const payOrderByShopeePay = (params, config = {}) => {
  const uri = `${constants.API.payment.pay_order}`
  return postViaWebWorker(uri, params, config)
}

export const payOrderByShopeePayWithAutoDebit = (params) => {
  const uri = `${constants.API.payment.pay_order}`
  return postViaWebWorker(uri, params, {
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Is-Auto-Debit': true
    }
  })
}

export const getShopeePayToken = (param) => {
  const uri = `${constants.API.payment.shopeepay.pay_token}`
  return get(uri, param, {
    // token_required: false,
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

export const createVirtualAccount = (param) => {
  const uri = `${constants.API.payment.virtual_account}`
  return postViaWebWorker(uri, param, {
    // token_required: false,
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
  })
}

export const payReimbursementFee = (params) => {
  const uri = constants.API.payment.reimbursement
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getAccessToken = (params) => {
  const uri = constants.API.payment.access_token
  return getViaWebWorker(uri, params)
}

export const getWithdrawalCod = (params) => {
  const uri = constants.API.payment.withdrawal_cod
  return getViaWebWorker(uri, params)
}

export const getAllTransactionTypes = (params) => {
  const uri = constants.API.user.transaction_types
  return get(uri, params, {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 7000
  })
}
export const deleteAccount = (params) => {
  const uri = constants.API.user.delete_account
  return put(uri, params)
}
export const verifyOTPLogin = (params) => {
  const uri = constants.API.user.auth.verifyOTPLogin
  return post(uri, params, { token_required: false, stringify_data: false })
}

export const validatePassCode = (params) => {
  const uri = constants.API.user.auth.validatePassCode
  return put(uri, params, { stringify_data: false })
}

export const updatePassCode = (params) => {
  const uri = constants.API.user.auth.updatePassCode
  return put(uri, params, { stringify_data: false })
}

export const forgotPassCode = (params) => {
  const uri = constants.API.user.auth.forgotPassCode
  return post(uri, params, { token_required: false, stringify_data: false })
}

export const resetPassCode = (params) => {
  const uri = constants.API.user.auth.resetPassCode
  return put(uri, params, { stringify_data: false })
}

export const getPaymentMethodsUser = (params) => {
  const uri = `${constants.API.payment.payment_customers}${params.payment_type}`
  return getViaWebWorker(uri, params, {
    token_required_header: true,
    headers: {
      'accepts-version': '3'
    }
  })
}

export const postPaymentSourceCard = (body) => {
  const uri = constants.API.payment.source_cards
  return postViaWebWorker(uri, body, { token_required_header: true })
}

export const putPaymentDefault = (method_id, params) => {
  const uri = constants.API.payment.set_default_payment + '/' + method_id + '/default'
  return put(uri, params, { token_required_header: true, header_json: true })
}

export const delPayment = (method_id) => {
  const uri = constants.API.payment.delete_payment + '/' + method_id
  return removeHaveData(
    uri,
    {
      provider: 'vnpay'
    },
    { token_required_header: true }
  )
}

export const transactions = (params) => {
  const uri = constants.API.user.transaction
  return getViaWebWorker(uri, params, { token_required_header: true })
}

// trusted partners

export const getListPartner = (params) => {
  const uri = constants.API.user.trusted_partner
  return getViaWebWorker(uri, params, { token_required_header: true })
}
// delete trusted partner
export const removeTrustedPartner = (params) => {
  const uri = constants.API.user.trusted_partner + `/${params.partner_id}`
  return remove(uri, {}, { token_required_header: true })
}
// add trusted partner
export const addTrustedPartner = (params) => {
  const uri = constants.API.user.trusted_partner
  return postViaWebWorker(uri, params, { token_required_header: true })
}

export const verifyV4Fn = (params) => {
  const uri = constants.API.user.auth.verifyV4
  const body = {
    ...params,
    fcm: true,
    push: 'web'
  }
  return post(uri, body, { token_required: false, stringify_data: false })
}

// OW-1567: refresh access token. BE nhận {mobile, refresh_token, type, imei} (JSON body).
export const refreshAccessTokenFn = ({ mobile, refresh_token, type, imei }) => {
  const uri = constants.API.user.auth.refreshToken
  return post(
    uri,
    { mobile, refresh_token, type, imei },
    { token_required: false, stringify_data: false }
  )
}
export const methodLoginV4Fn = (params) => {
  const uri = constants.API.user.auth.methodLoginV4
  return post(uri, params, { token_required: false, stringify_data: false })
}
export const loginV4Fn = (params) => {
  const uri = constants.API.user.auth.loginV4
  return post(uri, params, { token_required: false, stringify_data: false })
}
